var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    providerName,
    providerUrl,
    providerOmniturename
  } = options;

__p+='\n\n\nIn order to get the '+
((__t=( providerName ))==null?'':__t)+
' rate, please identify yourself as a '+
((__t=( providerName ))==null?'':__t)+
' customer.\nRates are subject to change without notice and may vary branch to branch.\n<a href="'+
((__t=( providerUrl ))==null?'':__t)+
'" target="_blank" data-omtag="ldp:rr:rate-table:'+
((__t=( providerOmnitureName ))==null?'':__t)+
':pop-up:more"> More</a>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage_rate_header_popover.jst.ejs